import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RiTimeLine, RiCheckLine } from '@remixicon/react';
import { useQueryClient } from '@tanstack/react-query';
import Button from '@components/ui/Button';
import { TrustJetPlane, TrustJetLogoV2 } from '@assets/images';
import { ROUTES } from '@/constants';

const WireTransferConfirmed = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const isTokenBasedCheckout = searchParams.get('token');

  const handleFinish = async () => {
    await queryClient.invalidateQueries({ queryKey: ['quotes'] });
    navigate(ROUTES.QUOTES.path);
  };

  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center p-4 relative"
      style={{
        backgroundImage: `url(${TrustJetPlane})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative z-10 flex flex-col items-center w-full max-w-lg">
        <div className="flex items-center gap-2 mb-8">
          <img src={TrustJetLogoV2} alt="TrustJet" className="h-14" />
        </div>

        <div className="bg-white/20 backdrop-blur-md rounded-3xl p-6 w-full">
          <h1 className="text-3xl md:text-4xl font-semibold text-white mb-6 text-center">
            Wire Transfer Initiated
          </h1>

          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl w-full overflow-hidden">
            <div className="p-8 text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-5">
                <RiTimeLine className="w-8 h-8 text-amber-600" />
              </div>

              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Payment Pending
              </h2>

              <p className="text-gray-600 mb-2">
                Thank you for initiating your wire transfer.
              </p>
              <p className="text-gray-500 text-sm mb-6">
                We'll process your booking as soon as the payment is received. This typically takes 1–3 business days. You'll receive a confirmation email once the transfer has been verified.
              </p>

              <div className="bg-gray-50 rounded-xl p-4 text-left space-y-2 mb-6">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <RiCheckLine className="w-4 h-4 text-green-500 flex-shrink-0" />
                  <span>Quote status updated to In Transit</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <RiCheckLine className="w-4 h-4 text-green-500 flex-shrink-0" />
                  <span>Flight details have been created</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <RiTimeLine className="w-4 h-4 text-amber-500 flex-shrink-0" />
                  <span>Awaiting wire transfer confirmation</span>
                </div>
              </div>
            </div>
          </div>

          {!isTokenBasedCheckout && (
            <div className="mt-4">
              <Button
                variant="secondary"
                className="w-full py-3 rounded-full flex items-center justify-center gap-2 !bg-white text-gray-800 font-medium"
                onClick={handleFinish}
              >
                Finish
                <RiCheckLine className="w-5 h-5" />
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WireTransferConfirmed;
